// The static width of the left rail, where account switcher & module switcher live.
export const APP_BAR_STATIC_WIDTH = 48;
export const APP_BAR_WITH_LABELS_STATIC_WIDTH = 68;
